/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} File_Export_Dialogue_List_AriaInputs */



/**
* | output |
* | --- |
* | "Export dialogue list" |
*
* @param {File_Export_Dialogue_List_AriaInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const file_export_dialogue_list_aria = /** @type {((inputs?: File_Export_Dialogue_List_AriaInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<File_Export_Dialogue_List_AriaInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Exporter la liste des dialogues")
	if (locale === "de") return /** @type {LocalizedString} */ ("Dialogliste exportieren")
	if (locale === "it") return /** @type {LocalizedString} */ ("Esporta elenco dialoghi")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Экспорт списка диалогов")
	if (locale === "es") return /** @type {LocalizedString} */ ("Lista de diálogo de exportación")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("导出对话框列表")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ダイアログリストをエクスポート")
	if (locale === "hi") return /** @type {LocalizedString} */ ("निर्यात संवाद सूची")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Lista de diálogo de exportação")
	return /** @type {LocalizedString} */ ("Export dialogue list")
});